import createModel from './lib/create_model';

var ContentPlaceholder = createModel({
  modelName: 'ContentPlaceholder',

  properties: {
    isLoading: Boolean,
  },
});

export default ContentPlaceholder;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/content_placeholder.js